import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import speciesName from '../utils/speciesName';
import wantsCol from '../utils/wantsCol';
import speciesListFilter from '../utils/speciesListFilter';
/**
 * "Descriptions" box on the species page - links to every "Descriptions"-
 * tagged discussion for this species or any of its synonyms (see
 * SpeciesDescriptionsService), mirroring champis.net's own list-group box.
 * Reuses DescriptionsPage.js's own .ChampisDescriptionsList* classes
 * rather than inventing new ones - same "boxed list under the blue header"
 * look, just fed one species' descriptions instead of the whole list.
 *
 * A description filed under a synonym rather than this exact species shows
 * that synonym's own name, plus a small link to its own species page (the
 * external-link icon) so it's clear why the name differs from this page's.
 * Renders nothing while loading or empty, same as SpeciesGallery.
 */
export default class SpeciesDescriptionsBox extends Component {
  descriptions = null;
  oninit(vnode) {
    super.oninit(vnode);
    this.descriptions = null;
    this.load(this.attrs.gbifId, this.attrs.colId);
  }
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    if (vnode.attrs.gbifId !== this.attrs.gbifId || vnode.attrs.colId !== this.attrs.colId) {
      this.load(vnode.attrs.gbifId, vnode.attrs.colId);
    }
  }
  load(gbifId, colId) {
    this.descriptions = null;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/species-descriptions',
      params: {
        filter: speciesListFilter(gbifId, colId)
      }
    }).then(response => {
      this.descriptions = (response.data || []).map(item => ({
        id: item.id,
        ...item.attributes
      }));
      m.redraw();
    }).catch(() => {
      this.descriptions = [];
      m.redraw();
    });
  }
  view() {
    if (!this.descriptions || this.descriptions.length === 0) {
      return null;
    }

    // A description filed under another species than the one this page
    // shows gets a link to that species' own page - by COL id on a COL-mode
    // page (both sides are the accepted taxon's there, see
    // ColIdLookup::forLink()), by gbif_id otherwise.
    const isOtherSpecies = d => this.attrs.colId ? d.colId !== this.attrs.colId : d.gbifId !== Number(this.attrs.gbifId);
    return [m("h2", {
      className: "ChampisDiscussionList-header"
    }, m("i", {
      className: "icon fas fa-file-alt",
      "aria-hidden": "true"
    }), " ", app.translator.trans('champis-species.forum.species_page.descriptions_header')), m("div", {
      className: "ChampisDescriptionsList"
    }, m("ul", {
      className: "ChampisDescriptionsList-items"
    }, this.descriptions.map(d => m("li", {
      key: d.id
    }, m(Link, {
      href: app.route.description(d.discussionId, d.canonicalName),
      className: "ChampisDescriptionsList-item"
    }, m("span", {
      className: "ChampisDescriptionsList-name"
    }, speciesName(d), isOtherSpecies(d) && m('[', null, ' ', m(Link, {
      href: d.colId && wantsCol() ? app.route.taxon(d.colId, d.canonicalName) : app.route.species(d.gbifId, d.canonicalName),
      onclick: e => e.stopPropagation()
    }, m("i", {
      className: "icon fas fa-external-link-alt",
      "aria-hidden": "true"
    })))), d.authorName && m("div", {
      className: "ChampisDescriptionsList-author"
    }, app.translator.trans('champis-species.forum.gallery.by', {
      name: d.authorName
    })))))))];
  }
}
flarum.reg.add('champis-species', 'forum/components/SpeciesDescriptionsBox', SpeciesDescriptionsBox);